import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useTranslation } from "next-i18next";

const stage = "://stage.mycargill.com";
const linkToProd_href = process.env.NEXT_PUBLIC_MY_CARGILL_URL_PROD_HREF;
const linkToProd_display = process.env.NEXT_PUBLIC_MY_CARGILL_URL_PROD_DISPLAY;

export function EnvironmentWarningForStage() {
  const { t } = useTranslation();
  const [showWarning, setShowWarning] = useState(false);
  const [host, setHost] = useState("");

  useEffect(() => {
    const currentHref = window.location.href;
    const currentHost = window.location.host;

    if (currentHref.includes(stage)) {
      setShowWarning(true);
    }
    setHost(currentHost);
  }, []);

  if (!showWarning) {
    return null;
  }

  return (
    <Box>
      <Alert severity="warning">
        <AlertTitle>
          {host} {t("request_access:env_warning.alert_title")}
        </AlertTitle>
        <p>
          {t("request_access:env_warning.body_part1")}{" "}
          <strong>
            <code>{host}</code>
          </strong>{" "}
          {t("request_access:env_warning.body_part2")}
          <br />
          {t("request_access:env_warning.body_part3")}{" "}
          <strong>
            <a href={linkToProd_href} target="_blank">
              {linkToProd_display}
            </a>
          </strong>{" "}
          {t("request_access:env_warning.body_part4")}
        </p>
      </Alert>
    </Box>
  );
}
